import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/context/AuthContext';
import { langPath } from '@/utils/langPath';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const ProtectedRoute = () => {
  const { isLoggedIn, roleType } = useAuth();
  const location = useLocation();
  const { i18n, t } = useTranslation();
  const pathname = location.pathname;

  useEffect(() => {
    const pathLng = pathname.split('/')[1];
    if (pathLng && i18n.language !== pathLng) {
      i18n.changeLanguage(pathLng);
    }
    const updateHtmlLang = (lng: string) => {
      document.documentElement.lang = lng;
    };

    updateHtmlLang(i18n.language);
    i18n.on('languageChanged', updateHtmlLang);

    return () => {
      i18n.off('languageChanged', updateHtmlLang);
    };
  }, [location.pathname, i18n, pathname]);

  const isLoginPage = pathname === langPath('/login');

  if (isLoggedIn === undefined || roleType === undefined) {
    return null;
  }

  if (!isLoggedIn && !isLoginPage) {
    return (
      <Navigate to={langPath('/login')} replace state={{ from: pathname }} />
    );
  }

  const partnerCheck =
    roleType === 'CENTER' ||
    roleType === 'PLANNER' ||
    roleType === 'MGG_CENTER';

  console.log('roleType', roleType, partnerCheck, isLoginPage);

  if (!partnerCheck && !isLoginPage) {
    return <Navigate to={langPath('/login')} replace />;
  }

  return <Outlet />;
};
